/**
 * HeroSection - Main headline for payment page
 *
 * Mobile: Lock icon on right, headline with "Take control" in orange
 * Desktop: Same but without lock icon (it's in header)
 * Note: Trial badge removed - trial info is now in pricing box
 */

import { LockIcon } from '@/components/icons/lock-icon';

interface HeroSectionProps {
  /** Whether to show the subheadline (hidden when features are above fold) */
  showSubhead?: boolean;
  /** Whether this is a multi-disease cohort (changes headline) */
  isMultiDiseaseCohort?: boolean;
}

export function HeroSection({ showSubhead = true, isMultiDiseaseCohort = false }: HeroSectionProps) {
  return (
    <div className="flex flex-col gap-1 pt-3 lg:pt-0">
      {/* Main headline with lock icon inline - mobile only shows lock */}
      <div className="flex items-start justify-between gap-4">
        <h1 className="text-[30px] font-bold leading-[1.3] lg:text-5xl">
          <span className="text-catch-salmon">Take control</span>
          <span className="text-catch-dark-blue-90">
            {isMultiDiseaseCohort
              ? ' of the four health risks that matter most.'
              : ' of your cancer risk.'}
          </span>
        </h1>

        {/* Lock icon - mobile only, inline with headline */}
        <div className="flex-shrink-0 lg:hidden">
          <div className="flex items-center justify-center rounded-full bg-slate-100 p-2">
            <LockIcon className="h-3.5 w-3.5 text-catch-dark-blue-90" />
          </div>
        </div>
      </div>

      {/* Subheadline - hidden when features are above fold */}
      {showSubhead && (
        <p className="text-sm leading-relaxed text-slate-500 lg:text-lg">
          No more guessing, no more spiraling. Just a clear, science-backed plan
          that puts your health in your hands.
        </p>
      )}
    </div>
  );
}

export default HeroSection;
